module.exports = __webpack_public_path__ + "static/img/8.24e8ddc0.jpg";